export const ROLE_BASED_ACCESS_SECTION_EVENT =
	'canvas-agent:role-based-access:section';
export const ROLE_BASED_ACCESS_FILTER_EVENT =
	'canvas-agent:role-based-access:filter';
export const ROLE_BASED_ACCESS_FOCUS_EVENT =
	'canvas-agent:role-based-access:focus';
export const ROLE_BASED_ACCESS_CREATE_MODAL_EVENT =
	'canvas-agent:role-based-access:create-modal';
export const ROLE_BASED_ACCESS_EDIT_MODAL_EVENT =
	'canvas-agent:role-based-access:edit-modal';
export const ROLE_BASED_ACCESS_DELETE_MODAL_EVENT =
	'canvas-agent:role-based-access:delete-modal';
